import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Typography } from 'antd';
import { color } from '../../../../../resources/color';
import { getClaimStatusTextColor, getClaimStatusBgColor } from '../../../hooks/useGetStatus';
import { ImageTheme } from '../../../../../components/images';

const { Text } = Typography;
export const WaitClaimContentCard = memo((props) => {
  const { item } = props;
  const productImageUrl = item && item.productImageUrl ? item.productImageUrl : '';
  const claimCode = item && item.claimCode ? item.claimCode : '-';
  const warrantyCode = item && item.warrantyCode ? item.warrantyCode : '-';
  const mobileModelName = item && item.mobileModelName ? item.mobileModelName : '-';
  const productName = item && item.productName ? item.productName : '-';
  const expireDate = item && item.expireDate ? moment(item.expireDate).format('DD/MM/YYYY') : '-';
  const telephone = item && item.telephone ? item.telephone : '-';
  const claimStatus = item && item.claimStatus ? item.claimStatus : 'NONE';
  const claimStatusName = item && item.claimStatusName ? item.claimStatusName : '-';
  const textColorStatus = getClaimStatusTextColor(claimStatus);
  const bgColorStatus = getClaimStatusBgColor(claimStatus);
  const bookingDate =
    item && item.bookingDate ? moment(item.bookingDate).format('DD/MM/YYYY') : '-';

  return (
    <div
      style={{
        borderRadius: '0px 25px 25px 0px',
        padding: '5px 5px 0 0',
        boxSizing: 'border-box',
        lineHeight: '1.5714285714285714',
        backgroundColor: '#ffffff',
        border: '1px solid #f0f0f0',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        width: '100%',
        marginBottom: '10px',
      }}
    >
      <Row gutter={10} style={{ paddingLeft: '10px' }}>
        <Col className="gutter-row" span={8}>
          <Row>
            <ImageTheme
              src={productImageUrl}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                marginTop: '10px',
              }}
            />
          </Row>
        </Col>
        <Col className="gutter-row" span={16}>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`รหัสรับประกัน:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ color: color.blueFocus, fontSize: 12 }}>
                {warrantyCode}
              </Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`รหัสการเคลม:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ color: color.blueFocus, fontSize: 12 }}>
                {claimCode}
              </Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`รุ่น:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ fontSize: 12 }}>
                {mobileModelName}
              </Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`ชื่อสินค้า:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ fontSize: 12 }}>
                {productName}
              </Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`สิ้นสุดประกัน:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ color: color.red, fontSize: 12 }}>{`${expireDate}`}</Text>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col className="gutter-row" span={10}>
              <Text style={{ fontSize: 12 }}>{`เบอร์ลูกค้า:`}</Text>
            </Col>
            <Col className="gutter-row" span={14}>
              <Text strong style={{ fontSize: 12 }}>
                {telephone}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row
        gutter={10}
        style={{
          marginTop: '15px',
          padding: '10px',
          backgroundColor: bgColorStatus,
          borderRadius: '0 0 25px 0',
        }}
      >
        <Col span={24}>
          <Row>
            <Col span={8} style={{ textAlign: 'start' }}>
              <Text style={{ fontSize: 15 }}>{`สถานะการเคลม: `}</Text>
            </Col>
            <Col span={16}>
              <Text strong style={{ fontSize: 15, color: textColorStatus }}>
                {claimStatusName} - ลูกค้ารอรับบริการวันที่ {bookingDate}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
});

WaitClaimContentCard.propTypes = {
  item: PropTypes.shape({
    productImageUrl: PropTypes.string,
    claimCode: PropTypes.string,
    warrantyCode: PropTypes.string,
    mobileModelName: PropTypes.string,
    productName: PropTypes.string,
    expireDate: PropTypes.string,
    fullName: PropTypes.string,
    telephone: PropTypes.string,
    claimStatusName: PropTypes.string,
    claimStatus: PropTypes.string,
    shippingName: PropTypes.string,
    trackingNumber: PropTypes.string,
  }),
};

WaitClaimContentCard.defaultProps = {
  item: null,
};
